/*
import path from 'path-browserify';

import { useTenantStore } from '@stores/tenant-store';
import { getBaseUrl } from '@api/base-url';

type DomainType = string | null;

const getDomain = () => useTenantStore().domain;

const base = ({
  domain,
}: {
  domain: DomainType;
}): string => path.join(
  getBaseUrl({ version: 1 }),
  `tenants/${domain}/admin/`,
);
*/

const urls = Object.freeze({
});

export default urls;
